import React from 'react';

// Styles
import * as S from './styles';

// Components
import SecondaryButton from '@/main/components/shared/button/secondaryButton';
import KogModalFadeComponent from '@/main/components/modal/ModalFadeComponent';

// Utils
import { getTranslateByKey } from '@/main/services/utils';

interface IModalAllowSSOAlertProps {
  isOpenModal: boolean;
  setIsOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  closeModal: () => void;
}
function ModalAllowSSOAlert({
  closeModal,
}: IModalAllowSSOAlertProps) {
  // Constants
  const PREFIX_ID_ELEMENTS_MODAL = 'id-modalAllowSSOAlert-';
  // States

  return (
    <S.ContainerModal>
      <h6></h6>
      <S.ContainerAlertMessage>
        {getTranslateByKey('information.popUpSSOMessage')}
      </S.ContainerAlertMessage>
      <S.AreaButtons>
        <SecondaryButton
          id={`${PREFIX_ID_ELEMENTS_MODAL}btn-evaluate-later`}
          type="button"
          onClick={() => {
            closeModal();
          }}>
          {getTranslateByKey('information.ok')}
        </SecondaryButton>
      </S.AreaButtons>
    </S.ContainerModal>
  );
}

function WrapperModalAllowSSOAlert(
  props: IModalAllowSSOAlertProps
) {
  return (
    <KogModalFadeComponent
      open={props.isOpenModal}
      setOpen={props.setIsOpenModal}>
      <ModalAllowSSOAlert {...props} />
    </KogModalFadeComponent>
  );
}

export default WrapperModalAllowSSOAlert;
